export const templateModel = {

  uid: null,
  bodyMail: null,
  imgFooter: {},
  imgHeader: {},
  nameSender: null,
  subject: null,
  headerShow: true,
  footerShow: true,
  user: {},
  testPlaceholter: {},

  reset () {
    this.uid = null
    this.bodyMail = null
    this.imgFooter = {}
    this.imgHeader = {}
    this.nameSender = null
    this.subject = null
    this.headerShow = true
    this.footerShow = true
    this.user = {}
    this.testPlaceholter = {}
  }

}
